import React, { useRef } from 'react';

interface BorderedTextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  className?: string;
  textClassName?: string;
}

const BorderedTextarea: React.FC<BorderedTextareaProps> = ({
  label,
  error,
  className,
  textClassName,
  value,
  onChange,
  ...textareaProps
}) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  return (
    <div className="flex flex-col w-full">
      <div
        className={`group relative rounded w-full ${error ? 'border-red-500' : ''} ${className || ''}`}
        style={{
          paddingLeft: '1px',
          paddingRight: '5px',
          paddingTop: '1px',
          paddingBottom: '5px',
        }}
      >
        {label && (
          <label className="absolute -top-2 left-3 mb-1 text-xs font-light text-gray-500 z-10 pointer-events-none bg-white px-1">
            {label}
          </label>
        )}
        <textarea
          ref={textareaRef}
          className={`
            appearance-none bg-transparent w-full px-3 py-2 rounded transition-all duration-300
            border-1 border-transparent 
            group-hover:border-gray-500 
            group-hover:border 
            focus:outline-none
            focus:border-blue-500
            resize-none
            min-h-[120px]
            ${textClassName || 'text-gray-700'}
            ${error ? 'group-hover:border-red-500 group-focus-within:border-red-500 border border-red-500' : ''}
          `}
          value={value}
          onChange={onChange}
          {...textareaProps}
        />
      </div>
      {error && (
        <span className="mt-1 text-xs text-red-500">
          {error}
        </span>
      )}
    </div>
  );
};

export default BorderedTextarea;

